import React from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { brands } from "../mock";

const BrandsStrip = () => {
  return (
    <section className="flex items-center gap-5 overflow-hidden">
      <div className="shrink-0">
        <div className="text-[15px] font-bold text-gray-800 leading-tight">
          Top Trusted Brands
        </div>
        <button
          onClick={() => toast.info("Full brand catalogue coming soon in the live version")}
          className="flex items-center gap-1 text-[11.5px] font-semibold text-[#0e7a3d] mt-0.5 hover:gap-2 transition-all"
        >
          View All Brands <ArrowRight size={12} />
        </button>
      </div>
      <div className="flex items-center gap-7 xl:gap-9 overflow-x-auto no-scrollbar py-1 flex-1">
        {brands.map((b) => (
          <span
            key={b.name}
            className={`${b.style} text-[15px] xl:text-[17px] whitespace-nowrap cursor-pointer opacity-80 hover:opacity-100 hover:scale-105 transition-[opacity,transform] duration-200 select-none`}
            onClick={() => toast.info(`${b.name} products coming soon in the live version`)}
          >
            {b.name}
          </span>
        ))}
      </div>
    </section>
  );
};

export default BrandsStrip;
